import React from "react";
import FormToAddStudent from "../../componentsGeneral/componentsSuperUser/formToAddStudent/FormToAddStudent";

const AddStudents = () => {
  return (
    <div>
      <FormToAddStudent />
    </div>
  );
};

export default AddStudents;
